// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.review-wrapper {
  margin: 0 16.66%;
  font-size: 16px;
}
.review-wrapper h1 {
  margin: 30px 0;
}
.review-wrapper .alert {
  margin-bottom: 0;
  margin-top: 20px;
}
.review-wrapper h2 {
  margin-top: 30px;
}
.review-wrapper .accordion {
  border-bottom: 1px solid #d2d2d2;
  margin-bottom: 20px;
}
.review-wrapper .fan-list {
  margin-bottom: 30px;
}
.review-wrapper .icon-alert {
  width: 20px;
  height: 20px;
  color: #ffb81c;
}
.review-wrapper .panel-header {
  background-color: hsl(0, 0%, 95%);
  border: 0;
  margin: 0;
}
.review-wrapper .panel-header .panel-message {
  padding: 20px 10px 1px 30px;
  font-size: 16px;
}
.review-wrapper .banner {
  background-color: hsl(0, 0%, 95%);
  padding: 8px;
  border-radius: 8px;
}
.review-wrapper .buttons-section {
  border-top: 1px solid #d2d2d2;
  margin-top: 30px;
  padding: 30px 0 60px;
}
.review-wrapper .buttons-section .btnCancel {
  font: 1.8rem;
}
.review-wrapper .buttons-section .btn-cancel {
  margin-right: 10px;
}
.review-wrapper .checkbox span {
  font-size: 16px;
}
.review-wrapper .btn-link {
  padding-top: 10px;
}
@media (max-width: 1024px) {
  .review-wrapper .btn-link {
    padding-top: 0;
  }
  .review-wrapper .btn {
    padding: 0;
  }
  .review-wrapper .buttons-section {
    padding: 30px 0;
  }
}
.review-wrapper app-customgrid div p {
  display: none;
}
.review-wrapper app-customgrid tr th:first-child {
  width: 10%;
}
@media (max-width: 1024px) {
  .review-wrapper {
    margin: 0 15px;
  }
  .review-wrapper .btn-cancel {
    margin: 20px 0 0;
    text-align: center;
    width: 100%;
  }
  .review-wrapper .btn {
    text-align: center;
    width: 100%;
  }
}

.review-wrappermdm {
  margin: 0 16.66%;
}
.review-wrappermdm h1 {
  margin: 30px 0;
}
.review-wrappermdm .alert {
  margin-bottom: 0;
  margin-top: 20px;
}
.review-wrappermdm h2 {
  margin-top: 30px;
}
.review-wrappermdm .accordion {
  border-bottom: 1px solid #d2d2d2;
  margin-bottom: 20px;
}
.review-wrappermdm .fan-list {
  margin-bottom: 30px;
}
.review-wrappermdm .icon-alert {
  width: 20px;
  height: 20px;
  color: #ffb81c;
}
.review-wrappermdm .panel-header {
  background-color: hsl(0, 0%, 95%);
  border: 0;
  margin: 0;
}
.review-wrappermdm .panel-header .panel-message {
  padding: 20px 10px 1px 30px;
}
.review-wrappermdm .banner {
  background-color: hsl(0, 0%, 95%);
  padding: 8px;
  border-radius: 8px;
}
.review-wrappermdm .buttons-section {
  border-top: 1px solid #d2d2d2;
  margin-top: 30px;
  padding: 30px 0 60px;
}
.review-wrappermdm .buttons-section .btnCancel {
  font: 1.8rem "Omnes-ATT-W02" !important;
}
.review-wrappermdm .buttons-section .btn-cancel {
  margin-right: 10px;
}
.review-wrappermdm .btn-link {
  padding-top: 10px;
}
@media (max-width: 1024px) {
  .review-wrappermdm .btn-link {
    padding-top: 0;
  }
  .review-wrappermdm .btn {
    padding: 0;
  }
  .review-wrappermdm .buttons-section {
    padding: 30px 0;
  }
}
.review-wrappermdm app-customgrid div p {
  display: none;
}
.review-wrappermdm app-customgrid tr th:first-child {
  width: 10%;
}
@media (max-width: 1024px) {
  .review-wrappermdm {
    margin: 0 15px;
  }
  .review-wrappermdm .btn-cancel {
    margin: 20px 0 0;
    text-align: center;
    width: 100%;
  }
  .review-wrappermdm .btn {
    text-align: center;
    width: 100%;
  }
}

@media (max-width: 1024px) {
  .review-wrapper,
  .review-wrappermdm {
    margin-top: 60px;
  }
  .review-wrapper h1,
  .review-wrapper h2,
  .review-wrappermdm h1,
  .review-wrappermdm h2 {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/cancel-participation/review-cancel/review-cancel.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,gBAAA;EAEA,eAAA;AAkJF;AAhJE;EACE,cAAA;AAkJJ;AA9IE;EACE,gBAAA;EACA,gBAAA;AAgJJ;AA7IE;EACE,gBAAA;AA+IJ;AA3IE;EACE,gCAAA;EACA,mBAAA;AA6IJ;AA1IE;EACE,mBAAA;AA4IJ;AAzIE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AA2IJ;AAxIE;EACE,iCAAA;EACA,SAAA;EACA,SAAA;AA0IJ;AAxII;EACE,2BAAA;EAEA,eAAA;AAyIN;AArIE;EACE,iCAAA;EACA,YAAA;EACA,kBAAA;AAuIJ;AApIE;EACE,6BAAA;EACA,gBAAA;EACA,oBAAA;AAsIJ;AApII;EACE,YAAA;AAsIN;AAnII;EACE,kBAAA;AAqIN;AAjIE;EAEE,eAAA;AAkIJ;AA9HE;EACE,iBAAA;AAgIJ;AFpLI;EEwDA;IACE,cAAA;EA+HJ;EA5HE;IACE,UAAA;EA8HJ;EA1HE;IACE,eAAA;EA4HJ;AACF;AAvHM;EACE,aAAA;AAyHR;AAnHQ;EACE,UAAA;AAqHV;AFrMI;EEtBJ;IA6GI,cAAA;EAkHF;EAhHE;IACE,gBAAA;IACA,kBAAA;IACA,WAAA;EAkHJ;EA/GE;IACE,kBAAA;IACA,WAAA;EAiHJ;AACF;;AA5GA;EACE,gBAAA;AA+GF;AA7GE;EACE,cAAA;AA+GJ;AA5GE;EACE,gBAAA;EACA,gBAAA;AA8GJ;AA3GE;EACE,gBAAA;AA6GJ;AA1GE;EACE,gCAAA;EACA,mBAAA;AA4GJ;AAzGE;EACE,mBAAA;AA2GJ;AAxGE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AA0GJ;AAvGE;EACE,iCAAA;EACA,SAAA;EACA,SAAA;AAyGJ;AAvGI;EACE,2BAAA;AAyGN;AArGE;EACE,iCAAA;EACA,YAAA;EACA,kBAAA;AAuGJ;AApGE;EACE,6BAAA;EACA,gBAAA;EACA,oBAAA;AAsGJ;AApGI;EACE,uCAAA;AAsGN;AApGI;EACE,kBAAA;AAsGN;AAjGE;EACE,iBAAA;AAmGJ;AFxQI;EEyKA;IACE,cAAA;EAkGJ;EA/FE;IACE,UAAA;EAiGJ;EA9FE;IACE,eAAA;EAgGJ;AACF;AA3FM;EACE,aAAA;AA6FR;AAvFQ;EACE,UAAA;AAyFV;AFzRI;EEuGJ;IAgGI,cAAA;EAsFF;EApFE;IACE,gBAAA;IACA,kBAAA;IACA,WAAA;EAsFJ;EAnFE;IACE,kBAAA;IACA,WAAA;EAqFJ;AACF;;AAhFA;EACE;;IAEE,gBAAA;EAmFF;EAlFE;;;;IAEE,gBAAA;IACA,mBAAA;EAsFJ;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.review-wrapper {\n  margin: 0 16.66%;\n  //font-family: 'ATTAleckSans-Regular' !important;\n  font-size: 16px;\n\n  h1 {\n    margin: 30px 0;\n    //font-family: 'ATTAleckSans-Regular' !important;\n  }\n\n  .alert {\n    margin-bottom: 0;\n    margin-top: 20px;\n  }\n\n  h2 {\n    margin-top: 30px;\n    //font-family: 'ATTAleckSans-Regular' !important;\n  }\n\n  .accordion {\n    border-bottom: 1px solid color(default, dark);\n    margin-bottom: 20px;\n  }\n\n  .fan-list {\n    margin-bottom: 30px;\n  }\n\n  .icon-alert {\n    width: 20px;\n    height: 20px;\n    color: #ffb81c;\n  }\n\n  .panel-header {\n    background-color: color(default, base);\n    border: 0;\n    margin: 0;\n\n    .panel-message {\n      padding: 20px 10px 1px 30px;\n      //font-family: 'ATTAleckSans-Regular' !important;\n      font-size: 16px;\n    }\n  }\n\n  .banner {\n    background-color: color(default, base);\n    padding: 8px;\n    border-radius: 8px;\n  }\n\n  .buttons-section {\n    border-top: 1px solid color(default, dark);\n    margin-top: 30px;\n    padding: 30px 0 60px;\n\n    .btnCancel {\n      font: 1.8rem;\n      //font-family: 'ATTAleckSans-Regular' !important;\n    }\n    .btn-cancel {\n      margin-right: 10px;\n    }\n  }\n\n  .checkbox span {\n    //font-family: 'ATTAleckSans-Regular' !important;\n    font-size: 16px;\n  }\n  \n\n  .btn-link {\n    padding-top: 10px;\n  }\n\n  @include respond-to(small) {\n    .btn-link {\n      padding-top: 0;\n    }\n\n    .btn {\n      padding: 0;\n      //font-family: 'ATTAleckSans-Regular' !important;\n    }\n\n    .buttons-section {\n      padding: 30px 0;\n    }\n  }\n\n  app-customgrid {\n    div {\n      p {\n        display: none;\n      }\n    }\n\n    tr {\n      th {\n        &:first-child {\n          width: 10%;\n        }\n      }\n    }\n  }\n\n  @include respond-to(small) {\n    margin: 0 15px;\n\n    .btn-cancel {\n      margin: 20px 0 0;\n      text-align: center;\n      width: 100%;\n    }\n\n    .btn {\n      text-align: center;\n      width: 100%;\n      //font-family: 'ATTAleckSans-Regular' !important;\n    }\n  }\n}\n\n.review-wrappermdm {\n  margin: 0 16.66%;\n\n  h1 {\n    margin: 30px 0;\n  }\n\n  .alert {\n    margin-bottom: 0;\n    margin-top: 20px;\n  }\n\n  h2 {\n    margin-top: 30px;\n  }\n\n  .accordion {\n    border-bottom: 1px solid color(default, dark);\n    margin-bottom: 20px;\n  }\n\n  .fan-list {\n    margin-bottom: 30px;\n  }\n\n  .icon-alert {\n    width: 20px;\n    height: 20px;\n    color: #ffb81c;\n  }\n\n  .panel-header {\n    background-color: color(default, base);\n    border: 0;\n    margin: 0;\n\n    .panel-message {\n      padding: 20px 10px 1px 30px;\n    }\n  }\n\n  .banner {\n    background-color: color(default, base);\n    padding: 8px;\n    border-radius: 8px;\n  }\n\n  .buttons-section {\n    border-top: 1px solid color(default, dark);\n    margin-top: 30px;\n    padding: 30px 0 60px;\n\n    .btnCancel {\n      font: 1.8rem 'Omnes-ATT-W02'!important;\n    }\n    .btn-cancel {\n      margin-right: 10px;\n    }\n  }\n  \n\n  .btn-link {\n    padding-top: 10px;\n  }\n\n  @include respond-to(small) {\n    .btn-link {\n      padding-top: 0;\n    }\n\n    .btn {\n      padding: 0;\n    }\n\n    .buttons-section {\n      padding: 30px 0;\n    }\n  }\n\n  app-customgrid {\n    div {\n      p {\n        display: none;\n      }\n    }\n\n    tr {\n      th {\n        &:first-child {\n          width: 10%;\n        }\n      }\n    }\n  }\n\n  @include respond-to(small) {\n    margin: 0 15px;\n\n    .btn-cancel {\n      margin: 20px 0 0;\n      text-align: center;\n      width: 100%;\n    }\n\n    .btn {\n      text-align: center;\n      width: 100%;\n    }\n  }\n}\n\n\n@media (max-width: 1024px) {\n  .review-wrapper,\n  .review-wrappermdm {\n    margin-top: 60px; \n    h1,\n    h2 {\n      margin-top: 15px;\n      margin-bottom: 15px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
